import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsSnowshoeNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M4.854 0a4 4 0 00-3.578 2.211l-.115.23A11 11 0 000 7.361v5.682c0 1.545 0 4.15.596 6.387.302 1.132.78 2.262 1.564 3.121C2.974 23.443 4.083 24 5.5 24c1.417 0 2.526-.557 3.34-1.449.785-.86 1.262-1.989 1.564-3.122.596-2.236.596-4.841.596-6.386V7.36a11 11 0 00-1.161-4.92l-.115-.23A4 4 0 006.146 0zM3.065 3.106A2 2 0 014.855 2h1.29a2 2 0 011.79 1.106l.115.23A9 9 0 018.993 7H2.007a9 9 0 01.943-3.664zM2 10.639l2.19 2.588-.372.44a1.978 1.978 0 00.11 2.676 2.222 2.222 0 003.143 0c.727-.727.776-1.89.111-2.676l-.372-.44L9 10.64V13c0 1.586-.006 3.953-.529 5.914-.26.977-.627 1.762-1.108 2.289-.451.494-1.03.797-1.863.797s-1.412-.303-1.863-.797c-.481-.527-.848-1.312-1.108-2.289C2.006 16.953 2 14.586 2 13zM3.233 9h4.534L5.5 11.68zM22.724 2.211A4 4 0 0019.146 0h-1.292a4 4 0 00-3.578 2.211l-.115.23A11 11 0 0013 7.361v5.682c0 1.545 0 4.15.596 6.387.302 1.132.78 2.262 1.564 3.121.814.892 1.923 1.449 3.34 1.449 1.417 0 2.526-.557 3.34-1.449.785-.86 1.262-1.989 1.564-3.122.596-2.236.596-4.841.596-6.386V7.36a11 11 0 00-1.161-4.92zM19.146 2a2 2 0 011.789 1.106l.115.23A9 9 0 0121.993 7h-6.986a9 9 0 01.943-3.664l.115-.23A2 2 0 0117.855 2zM15 13v-2.361l2.19 2.588-.372.44a1.978 1.978 0 00.11 2.676 2.222 2.222 0 003.143 0c.727-.727.776-1.89.111-2.676l-.372-.44L22 10.64V13c0 1.586-.006 3.953-.529 5.914-.26.977-.627 1.762-1.108 2.289-.451.494-1.03.797-1.863.797-.832 0-1.412-.303-1.863-.797-.481-.527-.848-1.312-1.108-2.289C15.006 16.953 15 14.586 15 13zm3.5-1.32L16.233 9h4.534z" />
      </g>
    </svg>
  )
);
SvgSportsSnowshoeNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsSnowshoeNormalSmall;
